import { Properties, Property, UserFilters, UserLocation } from '../../interfaces/interfaces';
import { getPropertiesFromElasticSearch } from './searchElastic';

export const fetchProperties = async (userLocation: UserLocation | null, filters: UserFilters, pageSize: number, pageNumber: number, propertyListSort: number): Promise<Properties> => {
	try {
		const propertyData = await getPropertiesFromElasticSearch(userLocation as UserLocation, filters, pageSize, pageNumber, propertyListSort);

		if (propertyData?.hits?.hits) {
			let propertiesArray: Property[] = propertyData?.hits?.hits.map((jsonData: any) => ({ ...jsonData._source, id: jsonData._id }));

			return { total: propertyData.hits.total.value, propertyArray: propertiesArray };

		} else {
			console.error('No Properties Returned. Probably a Bad Query. (CHP)');
			return { total: 0, propertyArray: [] };
		}
	}
	catch (error) {
		console.error('Problem fetching property data. (CHP): ', error);
		return { total: 0, propertyArray: [] };
	}
}